const normalize = (value: string | null | undefined): string => (value ?? '').trim().toUpperCase();

/** Service types arrive as "PARA" (portal-created) or "Para" (CRM-synced); always compare case-insensitively. */
export const sameServiceType = (a: string | null | undefined, b: string): boolean =>
  normalize(a) === normalize(b);

export const isParaServiceType = (value: string | null | undefined): boolean =>
  sameServiceType(value, 'PARA');

export const isSeitServiceType = (value: string | null | undefined): boolean =>
  sameServiceType(value, 'SEIT');

export const isSetssServiceType = (value: string | null | undefined): boolean =>
  sameServiceType(value, 'SETSS');
